import ReactGA from "react-ga";

const TRACKING_ID = "G-ZR272C77HT"; 
ReactGA.initialize(TRACKING_ID);

export const logPageView = () => {
    ReactGA.pageview(window.location.pathname + window.location.search);
};

export const logEvent = (category = "", action = "") => {
    if (category && action) {
        ReactGA.event({ category, action });
    }
};

export const logException = (description = "", fatal = false) => {
    if (description) {
        ReactGA.exception({ description, fatal });
    }
};